import React, { Component } from 'react';
import { Switch,  withRouter } from 'react-router-dom';

import FrontendAuth from '@/router/FrontendAuth'
import routerMap from '@/router/index'
import './App.css';

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      gray: false
    }
  }

  // static getDerivedStateFromError(error) {
  //   // 更新 state 使下一次渲染能够显示降级后的 UI
  //   return {hasError: true};
  // }

  componentDidMount() {
    document.getElementById('root').style.display = 'block';
    document.getElementById('appLoading').style.display = 'none';

    let date = new Date();

    let month = date.getMonth() + 1;
    let day = date.getDate();

    if (month === 5 && day === 12) {
      this.setState({ gray: true })
    }
    if (month === 4 && day === 4) {
      this.setState({ gray: true })
    }
  }

  // componentDidCatch(error, errorInfo) {
  //   // 你同样可以将错误日志上报给服务器
  //   console.error(error, errorInfo, 111);
  // }

  render() {
    return (
      <div className="App">
        <Switch>
          <FrontendAuth routerConfig={routerMap} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(App);
